import StorageKeys from "constants/StorageKeys";
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import checkIsValueEmpty from "utils/checkIsValueEmpty";



export function chooseNeedFieldValidation(fieldName) {
    return ({ field, form }) => {
      let currentFormDisableState = form.$(fieldName).disabled
      let currentFieldValue = field.value
      let showProductDropdown = localStorage.getItem(StorageKeys.SHOW_PRODUCT_DROPDOWN) === "true" ? true : false;
    
      if (!showProductDropdown && fieldName === 'products_list') {
        return [true, ""]
      }
  
      if (!currentFormDisableState && checkIsValueEmpty(currentFieldValue) &&  OptimizationStore.familyMemberModalType === FamilyMemberModalTypeEnum.ADD_NEED ) {
        return [false, "This field is mandatory"]
      } else {
        return [true, ""]
      }
    }
  }
  